// Page d'atterrissage après le flow OAuth Meta.
//
// Le backend redirige ici avec un query string :
//   ?success=1&handle=<username_ig>   → connexion réussie
//   ?error=<reason>                   → échec
//
// Cette page affiche un message clair puis redirige vers /dashboard après 3s.

import { useEffect } from 'react';
import { useSearchParams, Link, useNavigate } from 'react-router-dom';

export const InstagramCallback = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const success = params.get('success') === '1';
  const handle = params.get('handle');
  const error = params.get('error');

  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => navigate('/dashboard', { replace: true }), 3000);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [success, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-50 to-pink-50 px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center">
        {success ? (
          <>
            <div className="text-5xl mb-4">🎉</div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">
              Compte Instagram connecté !
            </h1>
            <p className="text-gray-600 mb-6">
              {handle ? (
                <>
                  <strong>@{handle}</strong> est désormais relié à Falko. Les commentaires
                  vont commencer à arriver dans ton dashboard.
                </>
              ) : (
                <>Ton compte Instagram est désormais relié à Falko.</>
              )}
            </p>
            <p className="text-sm text-gray-500 mb-4">
              Redirection automatique vers ton dashboard…
            </p>
            <Link
              to="/dashboard"
              className="inline-block bg-purple-600 text-white px-6 py-2.5 rounded-lg font-medium hover:bg-purple-700 transition"
            >
              Aller au dashboard
            </Link>
          </>
        ) : (
          <>
            <div className="text-5xl mb-4">😕</div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">
              Connexion Instagram échouée
            </h1>
            <p className="text-gray-600 mb-2">Une erreur s'est produite :</p>
            <p className="text-sm bg-red-50 text-red-700 rounded p-3 font-mono mb-6 break-all">
              {error ?? 'Erreur inconnue'}
            </p>
            <div className="flex gap-3 justify-center">
              <Link
                to="/dashboard"
                className="inline-block bg-gray-200 text-gray-700 px-5 py-2 rounded-lg font-medium hover:bg-gray-300 transition"
              >
                Retour
              </Link>
              <a
                href="/api/auth/meta"
                className="inline-block bg-purple-600 text-white px-5 py-2 rounded-lg font-medium hover:bg-purple-700 transition"
              >
                Réessayer
              </a>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
